export default "__VITE_ASSET__b9f9f9d9__"